import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import ContentBlock from '@/components-latest/primitives/ContentBlock'
import Text from '@/components-latest/primitives/Text'
import CycleInfo from '@/components-latest/ui/BillingPage/CycleInfo'
import { IBillingCycle } from '@/ducks/billing/billing.types'

import Styles from './BillingCyclesList.module.scss'

const BillingCyclesList = ({
  type,
  cycles,
  onDetailsClick
}: {
  cycles: IBillingCycle[]
  type: 'paid' | 'unpaid'
  onDetailsClick?: (
    cycle: IBillingCycle | null,
    type: 'paid' | 'unpaid'
  ) => void
}) => {
  const { t } = useTranslation()

  if (!cycles || cycles.length === 0) return null

  return (
    <div className={Styles.wrapper}>
      <Text variant="nextSubtitle" weight="extraBold" className={Styles.title}>
        {t(`billing.cycle-list.title-${type}`)}
      </Text>
      <div className={Styles.list}>
        {cycles.map(cycle => (
          <ContentBlock className={Styles.cycleItem} key={cycle.billing_cycle}>
            <CycleInfo cycle={cycle} type={type} />
            <Button
              className={Styles.button}
              variant={type === 'unpaid' ? 'primary' : 'tertiary'}
              size="medium"
              onClick={() => {
                onDetailsClick?.(cycle, type)
              }}>
              {t(`billing.cycle-list.details-link-${type}`)}
            </Button>
          </ContentBlock>
        ))}
      </div>
    </div>
  )
}

export default BillingCyclesList
